interface IconProps {
  className?: string;
}

// Two sliders — the summary-card picker's trigger. Deliberately not ColumnsIcon: that one
// means table columns, and reusing it for the card band would make two different controls
// look like the same one.
export const SlidersIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M3 6.5H10.5M14.5 6.5H17M3 13.5H6.5M10.5 13.5H17"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="12.5" cy="6.5" r="1.75" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="8.5" cy="13.5" r="1.75" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const CopyIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6.5"
      y="6.5"
      width="10"
      height="11"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M13.5 6.5V4.5C13.5 3.94772 13.0523 3.5 12.5 3.5H4.5C3.94772 3.5 3.5 3.94772 3.5 4.5V12.5C3.5 13.0523 3.94772 13.5 4.5 13.5H6.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const ArchiveBoxIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 3.5H17.5V6.5H2.5V3.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 6.5V15.5C3.5 16.0523 3.94772 16.5 4.5 16.5H15.5C16.0523 16.5 16.5 16.0523 16.5 15.5V6.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M8 10H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const RestoreIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3 5V8.5H6.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Six-dot grip for a drag handle. Shared by every sortable list on a roster board so the handle
 * looks the same on the players table, a depth chart card, the pitching staff and a lineup.
 */
export const DragHandleIcon = () => (
  <svg width="10" height="16" viewBox="0 0 10 16" aria-hidden="true" focusable="false">
    <circle cx="2" cy="2" r="1.3" fill="currentColor" />
    <circle cx="8" cy="2" r="1.3" fill="currentColor" />
    <circle cx="2" cy="8" r="1.3" fill="currentColor" />
    <circle cx="8" cy="8" r="1.3" fill="currentColor" />
    <circle cx="2" cy="14" r="1.3" fill="currentColor" />
    <circle cx="8" cy="14" r="1.3" fill="currentColor" />
  </svg>
);

/*
  Move up / move down, the keyboard route through a sortable list. Drawn rather than typed as an
  arrow character: a glyph takes its size and shape from whatever font the row inherits, which is
  how the same control ends up a different size on two rows of the same table.
*/
export const ArrowUpIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M8 13V3" />
    <path d="M3.5 7.5 8 3l4.5 4.5" />
  </svg>
);

export const ArrowDownIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M8 3v10" />
    <path d="M3.5 8.5 8 13l4.5-4.5" />
  </svg>
);
